import React, { useState } from 'react';
import '../styles/TravaillerAuMusee.css';
import '../styles/Root.css';
import travailleraumuseeImage from '../assets/travailleraumusee/travailleraumusee.jpg';

const STAGES_LINK = "https://stages.defense.gouv.fr";

const TravaillerAuMusee = () => {
  const [statusMessage, setStatusMessage] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    setStatusMessage('Envoi en cours...');

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('/api/travailleraumusee.php', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erreur lors de l\'envoi du formulaire');
      }

      const result = await response.json();
      setStatusMessage('Message envoyé avec succès !');
      form.reset();
    } catch (error) {
      setError(error.message);
      setStatusMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <section className="hero fade-in">
        <h1>Travailler au musée</h1>
        <p>Rejoignez l'équipe du Musée des Troupes de Marine</p>
      </section>

      <section className="content-section fade-in">
        <h2>Postes Disponibles</h2>
        <p>
          Le musée des Troupes de marine propose plusieurs offres d'emplois et de stage à pourvoir.<br />
          Vous pouvez les consulter en ligne <a href={STAGES_LINK} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'var(--tdm-blue)' }}>ici</a>
        </p>
      </section>

      <section className="content-section fade-in">
        <h2>Pourquoi Travailler au Musée ?</h2>
        <p>Le Musée des Troupes de Marine et l'Association des Amis du Musée sont dédiés à la préservation et à la valorisation d'un patrimoine riche et varié. En rejoignant notre équipe, vous contribuerez à la réalisation de nos missions et à la promotion de l'histoire des Troupes de Marine.</p>
        <p>Nous croyons en l'importance de l'épanouissement personnel et professionnel de nos membres. Nous encourageons la formation continue, l'innovation, et la créativité. En travaillant au musée, vous aurez l'opportunité de développer vos compétences, de participer à des projets passionnants, et de faire partie d'une communauté dédiée à la préservation de l'histoire.</p>
      </section>

      <section className="image-section fade-in">
        <div className="image-container">
          <img src={travailleraumuseeImage} alt="Équipe du Musée des Troupes de Marine" className="team-image" />
        </div>
      </section>

      <section className="content-section fade-in">
        <h2>Notre Mission</h2>
        <p>Notre mission est de préserver et de valoriser le patrimoine des Troupes de Marine. Nous organisons des expositions, des conférences, et des événements culturels pour sensibiliser le public à l'histoire des Troupes de Marine. Nous travaillons également à la conservation des objets historiques et à la documentation de l'histoire militaire.</p>
        <p>En rejoignant notre équipe, vous contribuerez à la réalisation de ces missions et à la promotion de notre patrimoine. Vous aurez l'opportunité de participer à des projets passionnants et de faire partie d'une communauté dédiée à la préservation de l'histoire.</p>
      </section>

      <section className="form-section fade-in">
        <h2>Formulaire de Candidature</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="first-name">Prénom</label>
          <input type="text" id="first-name" name="first-name" required />

          <label htmlFor="last-name">Nom</label>
          <input type="text" id="last-name" name="last-name" required />

          <label htmlFor="email">Adresse Email</label>
          <input type="email" id="email" name="email" required />

          <label htmlFor="phone">Téléphone</label>
          <input type="tel" id="phone" name="phone" required />

          <label htmlFor="cover-letter">Lettre de Motivation</label>
          <textarea id="cover-letter" name="cover-letter" rows="5" required></textarea>

          <label htmlFor="resume">CV</label>
          <input type="file" id="resume" name="resume" required />

          <label htmlFor="cover-letter-file">Joindre une Lettre de Motivation</label>
          <input type="file" id="cover-letter-file" name="cover-letter-file" />

          {error && <div className="error-message">{error}</div>}
          {statusMessage && <div className="status-message">{statusMessage}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Envoi en cours...' : 'Envoyer'}
          </button>
        </form>
      </section>
    </main>
  );
};

export default TravaillerAuMusee;
